<template lang="pug">
.toast-atualizacao-territorio__content
    .toast-atualizacao-territorio__info
        i.el-icon-loading.toast-atualizacao-territorio__icon
        span.toast-atualizacao-territorio__texto
            | {{ textoProcessando }}
    .toast-atualizacao-territorio__progresso
        .toast-atualizacao-territorio__barra
            .toast-atualizacao-territorio__barra__fill(
                :style='{ width: `${percentual}%` }'
            )
        .toast-atualizacao-territorio__contador
            span.toast-atualizacao-territorio__contador__numero {{ atualizados }}
            span.toast-atualizacao-territorio__contador__separador /
            span.toast-atualizacao-territorio__contador__total {{ total }}
            span.toast-atualizacao-territorio__contador__texto {{ textoTerritorios }}
        .toast-atualizacao-territorio__percentual
            | {{ percentual }}%
</template>

<script>
export default {
    name: 'ToastAtualizacaoTerritorio',
    props: {
        atualizados: {
            type: Number,
            required: true,
            default: 0
        },
        total: {
            type: Number,
            required: true,
            default: 0
        },
        percentual: {
            type: Number,
            required: true,
            default: 0
        },
        textoProcessando: {
            type: String,
            required: true
        },
        textoTerritorios: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.toast-atualizacao-territorio__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.toast-atualizacao-territorio__info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.toast-atualizacao-territorio__icon {
    font-size: 18px;
    color: var(--primary);
    animation: rotating 2s linear infinite;
}

@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.toast-atualizacao-territorio__texto {
    font-size: 14px;
    color: var(--primary);
    font-weight: 500;
}

.toast-atualizacao-territorio__progresso {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.toast-atualizacao-territorio__barra {
    width: 100%;
    height: 8px;
    background-color: #f4f4f5;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
}

.toast-atualizacao-territorio__barra__fill {
    height: 100%;
    background: linear-gradient(90deg, var(--primary) 0%, var(--primary) 100%);
    border-radius: 4px;
    transition: width 0.3s ease;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.3) 50%,
            transparent 100%
        );
        animation: shimmer 1.5s infinite;
    }
}

@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

.toast-atualizacao-territorio__contador {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--primary);
}

.toast-atualizacao-territorio__contador__numero {
    font-weight: 700;
    font-size: 16px;
    color: var(--primary);
}

.toast-atualizacao-territorio__contador__separador {
    color: var(--primary);
    font-weight: 500;
}

.toast-atualizacao-territorio__contador__total {
    font-weight: 500;
    color: var(--primary);
}

.toast-atualizacao-territorio__contador__texto {
    margin-left: 4px;
    color: var(--primary);
    font-weight: 500;
}

.toast-atualizacao-territorio__percentual {
    text-align: right;
    font-size: 14px;
    font-weight: 600;
    color: var(--primary);
}
</style>
